import * as React from 'react'
import { translateCountryName } from "@ui-seeker/utils"

import {RetailerBlock} from "@components";


export default function retailerColumn() {
    return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	},{
        name: 'retailer', label: 'Retailer',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value, { country, date, siteURL, pageURL, siteID, productID }) => {
			return <>
				<RetailerBlock
					retailer={value}
					country={country}
					date={date}
					siteURL={siteURL}
					pageURL={pageURL}
				/>
			</>
			}
        }
    }]
}
